package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CompetenceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_070_491_842, arrayOf("competence"), driver, "Competence.sq",
      "selectAll",
      "SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE is_deleted = 0 ORDER BY family_id, order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Competence> = selectAll { id, family_id, skill_id, name,
      description, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence(
      id,
      family_id,
      skill_id,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Competence> = selectById(id) { id_, family_id, skill_id,
      name, description, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence(
      id_,
      family_id,
      skill_id,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByFamily(family_id: String, mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByFamilyQuery(family_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByFamily(family_id: String): Query<Competence> = selectByFamily(family_id) { id,
      family_id_, skill_id, name, description, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Competence(
      id,
      family_id_,
      skill_id,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBySkill(skill_id: String?, mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectBySkillQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectBySkill(skill_id: String?): Query<Competence> = selectBySkill(skill_id) { id,
      family_id, skill_id_, name, description, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Competence(
      id,
      family_id,
      skill_id_,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-2_046_800_205, arrayOf("competence"), driver, "Competence.sq",
      "selectDirty",
      "SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Competence> = selectDirty { id, family_id, skill_id, name,
      description, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence(
      id,
      family_id,
      skill_id,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Competence> = selectByIdAnyState(id) { id_,
      family_id, skill_id, name, description, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Competence(
      id_,
      family_id,
      skill_id,
      name,
      description,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(96_097_820, """
        |INSERT INTO competence(id, family_id, skill_id, name, description, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, family_id)
          bindString(2, skill_id)
          bindString(3, name)
          bindString(4, description)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(96_097_820) { emit ->
      emit("competence")
    }
  }

  public fun update(
    family_id: String,
    skill_id: String?,
    name: String,
    description: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(441_044_012, """
        |UPDATE competence
        |SET family_id = ?, skill_id = ?, name = ?, description = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, family_id)
          bindString(1, skill_id)
          bindString(2, name)
          bindString(3, description)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(441_044_012) { emit ->
      emit("competence")
    }
  }

  public fun reorder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(2_115_647_992,
        """UPDATE competence SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(2_115_647_992) { emit ->
      emit("competence")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-113_555_368,
        """UPDATE competence SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-113_555_368) { emit ->
      emit("competence")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(2_119_412_619,
        """UPDATE competence SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(2_119_412_619) { emit ->
      emit("competence")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_089_338_250,
        """UPDATE competence SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_089_338_250) { emit ->
      emit("competence")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_174_449_967,
        """SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Competence.sq:selectById"
  }

  private inner class SelectByFamilyQuery<out T : Any>(
    public val family_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(272_815_130,
        """SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE family_id = ? AND is_deleted = 0 ORDER BY order_index, name""",
        mapper, 1) {
      bindString(0, family_id)
    }

    override fun toString(): String = "Competence.sq:selectByFamily"
  }

  private inner class SelectBySkillQuery<out T : Any>(
    public val skill_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE skill_id ${ if (skill_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY order_index, name""",
        mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "Competence.sq:selectBySkill"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_477_836_298,
        """SELECT competence.id, competence.family_id, competence.skill_id, competence.name, competence.description, competence.order_index, competence.created_at, competence.updated_at, competence.is_deleted, competence.deleted_at, competence.synced_at FROM competence WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Competence.sq:selectByIdAnyState"
  }
}
